import '../style.css';
import { mountTailChase } from './game';

mountTailChase();
